app.service('orderClass', function () {
	let $self;

	function init() {
		$self = $('#container');
	}

	function toggle(className, state) {
		$self.toggleClass(className, state);
	}

	function remove(className) {
		$self.removeClass(className);
	}

	function add(className) {
		$self.addClass(className);
	}

	return {
		init,
		toggle,
		remove,
		add
	};
});